import {
	type ActionFunctionArgs,
	json,
	type LoaderFunctionArgs,
	redirect,
} from '@remix-run/node'
import { Link, useLoaderData } from '@remix-run/react'
import { useEffect } from 'react'
import { LuTrash } from 'react-icons/lu'
import { H2, H3, Paragraph } from '#app/components/typography.tsx'
import { Button } from '#app/components/ui/button.tsx'
import { useCart } from '#app/hooks/useCart.tsx'
import shopifyClient from '#app/utils/shopify.server.ts'
import { getValue, addTrailingZeroes } from '#app/utils/util.ts'
import CartMutation from '../../libs/mutations/CartMutation.graphql'
import CartQuery from '../../libs/queries/CartQuery.graphql'

export function CartContent({ lines }) {
	return lines.edges.map((line: any) => {
		return (
			<div
				className="flex items-center justify-between gap-4"
				key={line.node.id}
			>
				<div className="flex items-center gap-4">
					<img
						src={line.node.merchandise.product.featuredImage.url}
						alt={line.node.merchandise.product.featuredImage.altText}
					/>
					<H3 className="mb-0">{line.node.merchandise.product.title}</H3>
				</div>
				<div className="flex items-center gap-4">
					<select>
						<option>1</option>
					</select>
					<Paragraph>{`€ ${addTrailingZeroes(line.node.merchandise.price.amount)}`}</Paragraph>
					{/* On click, fire delete with cartId and lineId. -> useFetcher for update? */}
					{/* <LuTrash
						size={'24px'}
						className="hover:cursor-pointer"
						onClick={() => console.log('Delete ID: ', line.node.id)}
					/> */}
				</div>
			</div>
		)
	})
}

export function CartTotals({ subtotal, total }) {
	return (
		<>
			<span className="flex justify-between">
				<Paragraph>Subtotaal</Paragraph>
				<Paragraph>{`€ ${addTrailingZeroes(subtotal.amount)}`}</Paragraph>
			</span>
			{/* <span className="flex justify-between">
	<Paragraph>Verzendkosten</Paragraph>
	<Paragraph>{`€ ${addTrailingZeroes(total.amount)}`}</Paragraph>
</span> */}
			<hr />
			<span className="flex justify-between">
				<Paragraph>Totaal</Paragraph>
				<Paragraph>{`€ ${addTrailingZeroes(total.amount)}`}</Paragraph>
			</span>
		</>
	)
}

export async function action({ request }: ActionFunctionArgs) {
	const formData = await request.formData()
	const merchandiseId = formData.get('merchandiseId')

	const shopifyResponse = await shopifyClient
		.request(CartMutation, {
			input: {
				lines: [{ merchandiseId, quantity: 1 }],
			},
		})
		.catch(error => {
			console.error('error: ', JSON.stringify(error))
			console.log(''.padEnd(100, '='))
		})

	let cartId = ''
	if (shopifyResponse) {
		cartId = shopifyResponse.cartCreate.cart.id
	}

	return redirect(`/winkelwagen?cartId=${encodeURIComponent(cartId)}`)
}

export async function loader({ request }: LoaderFunctionArgs) {
	const url = new URL(request.url)
	const cartId = url.searchParams.get('cartId')

	if (!cartId) {
		return json({
			subtotal: { amount: 0 },
			total: { amount: 0 },
			lines: { edges: [] },
			cartId: '',
			checkoutUrl: '',
		})
	}
	const shopifyResponse = await shopifyClient.request(CartQuery, {
		cartId: cartId,
	})

	const cart = shopifyResponse.cart || {}

	const subtotal = getValue(cart, 'cost.subtotalAmount', 0)
	const total = getValue(cart, 'cost.totalAmount', 0)
	const lines = getValue(cart, 'lines', [])

	console.log('total: ', total, subtotal)
	console.log(''.padEnd(100, '='))
	return json({
		subtotal,
		total,
		lines,
		cartId: cart.id,
		checkoutUrl: cart.checkoutUrl,
	})
}

export default function CartRoute() {
	const response = useLoaderData()
	const { subtotal, total, lines, cartId, checkoutUrl } = response
	console.log('response: ', response)
	console.log(''.padEnd(100, '*'))
	const { setCart } = useCart()

	useEffect(() => {
		if (cartId && checkoutUrl) {
			setCart(cartId, checkoutUrl)
		}
	}, [response])

	return (
		<section className="mx-auto mb-8 mt-8 flex max-w-7xl flex-col gap-10 px-8 pb-10 lg:grid lg:grid-cols-[2fr_1fr] lg:px-4 xl:w-11/12 2xl:w-10/12">
			<div>
				<H2>Mijn Winkelwagen</H2>
				{lines.edges.length > 0 ? (
					<CartContent lines={lines} />
				) : (
					<Paragraph>Geen producten in de winkelwagen</Paragraph>
				)}
				{/* <CartContent lines={lines} /> */}
			</div>
			<div className="flex flex-col gap-4">
				<H2>Besteloverzicht</H2>
				{total.amount > 0 ? (
					<CartTotals subtotal={subtotal} total={total} />
				) : (
					<Paragraph>Total: 0</Paragraph>
				)}
				{/* <CartTotals subtotal={subtotal} total={total} /> */}
				<Link
					to={checkoutUrl ? checkoutUrl : ''}
					target="_blank"
					className="w-full"
				>
					<Button
						className="w-full font-bold text-white"
						disabled={!checkoutUrl}
					>
						Afrekenen
					</Button>
				</Link>
				<Link to={'/wijn-cursussen'} className="w-full">
					<Button className="w-full" variant={'outline'}>
						Verder Winkelen
					</Button>
				</Link>
			</div>
		</section>
	)
}
